import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class FileGenerationService {

    constructor(private http: HttpClient) {  }

    downloadIQAPlan(data: any): Observable<any> {
        console.log("generating", data);

        return new Observable<any>((observer) => {
            console.log("Observable");
            this.http.post(config.baseApiUrl + "file-generation/IQAPlan", data).subscribe((res: any) => {
                observer.next(res.data);
            }, err => {
                observer.error(err)
            }, () => {
                observer.complete();
            })
        });

    }

    downloadIQAAssessment(data: any): Observable<any> {
        console.log("generating", data);

        return new Observable<any>((observer) => {
            console.log("Observable");
            this.http.post(config.baseApiUrl + "file-generation/IQAAssessment", data).subscribe((res: any) => {
                observer.next(res.data);
            }, err => {
                observer.error(err)
            }, () => {
                observer.complete();
            })
        });

    }
}
